import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  searchNotificationAPI,
  updateKdkFlgAPI,
  updateKdkFlgDetailAPI,
  updateKdkFlgDetailsAPI,
  detailNotificationAPI,
  updateNotificationAPI,
} from './api';
import {
  searchNotification,
  searchNotificationSuccess,
  searchNotificationFailure,
  updateKdkFlg,
  updateKdkFlgSuccess,
  updateKdkFlgFailure,
  updateKdkFlgDetail,
  updateKdkFlgDetailSuccess,
  updateKdkFlgDetailFailure,
  updateKdkFlgDetails,
  updateKdkFlgDetailsSuccess,
  updateKdkFlgDetailsFailure,
  isMdkNotification,
  isMdkNotificationSuccess,
  isMdkNotificationFailure,
  detailNotification,
  detailNotificationSuccess,
  detailNotificationFailure,
  updateNotification,
  updateNotificationSuccess,
  updateNotificationFailure,
} from './slice';

function* fetchSearchNotificationSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(searchNotificationAPI, trimQueryData(payload));
    yield put(searchNotificationSuccess(response.data));
  } catch (error) {
    yield put(searchNotificationFailure());
  }
}

function* fetchUpdateKdkFlgSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(updateKdkFlgAPI, trimQueryData(payload));
    yield put(updateKdkFlgSuccess(response.data));
  } catch (error: any) {
    yield put(updateKdkFlgFailure({ message: error?.message }));
  }
}

function* isMdkNotificationSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(searchNotificationAPI, trimQueryData(payload));
    yield put(isMdkNotificationSuccess(response.data));
  } catch (error: any) {
    yield put(isMdkNotificationFailure({ message: error?.message }));
  }
}

function* fetchUpdateKdkFlgDetailSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(updateKdkFlgDetailAPI, payload);
    yield put(updateKdkFlgDetailSuccess(response.data));
  } catch (error: any) {
    yield put(updateKdkFlgDetailFailure({ message: error?.message }));
  }
}

function* fetchUpdateKdkFlgDetailsSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(updateKdkFlgDetailsAPI, payload);
    yield put(updateKdkFlgDetailsSuccess(response.data));
  } catch (error: any) {
    yield put(updateKdkFlgDetailsFailure({ message: error?.message }));
  }
}

function* fetchDetailNotificationSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(detailNotificationAPI, payload);
    yield put(detailNotificationSuccess(response.data));
  } catch (error: any) {
    yield put(detailNotificationFailure({ message: error?.message }));
  }
}

function* fetchUpdateNotificationSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(updateNotificationAPI, payload);
    yield put(updateNotificationSuccess(response.data));
  } catch (error: any) {
    yield put(updateNotificationFailure({ message: error?.message }));
  }
}

function* watchNotification() {
  yield takeLatest(searchNotification, fetchSearchNotificationSaga);
  yield takeLatest(updateKdkFlg, fetchUpdateKdkFlgSaga);
  yield takeLatest(updateKdkFlgDetail, fetchUpdateKdkFlgDetailSaga);
  yield takeLatest(updateKdkFlgDetails, fetchUpdateKdkFlgDetailsSaga);
  yield takeLatest(isMdkNotification, isMdkNotificationSaga);
  yield takeLatest(detailNotification, fetchDetailNotificationSaga);
  yield takeLatest(updateNotification, fetchUpdateNotificationSaga);
}

export default watchNotification;
